import React, { UIEvent, useRef, useState } from 'react';
import styled from 'styled-components';

import { InspirationCategory, sortedCategories } from '../../lib/inspiration';
import ChevronRight from '../../components/icons/ChevronRight';
import ChevronLeft from '../../components/icons/ChevronLeft';

import { DeviceQueries } from 'Common/src/components/styled';

const PillRow = ({ onPillClick }: { onPillClick: (inspirationCategory?: InspirationCategory) => void}) => {
  const [scrollAtStart, setScrollAtStart] = useState(true);
  const [scrollAtEnd, setScrollAtEnd] = useState(false);

  const rowRef = useRef<HTMLDivElement>(null);

  const onRowScroll = (e: UIEvent<HTMLDivElement>) => {
    const scrollLeft = e.currentTarget.scrollLeft;
    if (scrollLeft === 0) {
      setScrollAtStart(true);
    } else if (scrollAtStart) {
      setScrollAtStart(false);
    }
    if (scrollLeft === (e.currentTarget.scrollWidth - e.currentTarget.offsetWidth)) {
      setScrollAtEnd(true);
    } else if (scrollAtEnd) {
      setScrollAtEnd(false);
    }
  };

  const scrollRow = (isRight: boolean) => {
    const row = rowRef.current;
    if (row === null) {
      return;
    }

    const distance = Math.floor(row.offsetWidth * 0.8);

    let target: number;
    if (isRight) {
      target = Math.min(row.scrollWidth - row.offsetWidth, row.scrollLeft + distance);
    } else {
      target = Math.max(0, row.scrollLeft - distance);
    }

    row.scrollTo({ behavior: 'smooth', left: target });
  };

  const categories = sortedCategories();

  return <CarouselWrapper>
    <ChevronWrapper onClick={() => scrollRow(false)}>
    {
      !scrollAtStart && <ChevronLeft/>
    }
    </ChevronWrapper>
    <Row onScroll={onRowScroll} ref={rowRef}>
      <BlackPill onClick={() => onPillClick}>
        <PillLabel>
          All categories
        </PillLabel>
      </BlackPill>

      {
        categories.map((category: InspirationCategory) => <Pill
          key={category} onClick={() => onPillClick(category)}>
            <PillLabel>
              {category}
            </PillLabel>
          </Pill>
        )
      }
    </Row>
    <ChevronWrapper onClick={() => scrollRow(true)}>
      {
        !scrollAtEnd && <ChevronRight/>
      }
    </ChevronWrapper>
  </CarouselWrapper>;
};

const CarouselWrapper = styled.div`
  display: flex;
  overflow: hidden;
  align-items: center;
  cursor: pointer;
  width: 100%;
  
  margin: 0 -40px;

  @media (${DeviceQueries.mobile}) {
    margin: 0 -20px;
  }
`;

const ChevronWrapper= styled.div`
  min-width: 40px;
  padding: 0 6px;
  box-sizing: border-box;
`;

const Row = styled.div`
  display: flex;
  gap: 16px;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;

  margin-bottom: -17px;
  padding-bottom: 17px;
`;

const Pill = styled.div`
  display: flex;
  padding: 7px 17px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 14px;
  border-radius: 171px;

  border: 1px solid #000;
  opacity: 0.8;
  background: #FFF;
`;

const BlackPill = styled(Pill)`
  background: #000;
  color: #FFF;
`;

const PillLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  white-space: nowrap;
`;

export default PillRow;
